import z from "zod"

export const GetLoopReturnsReturnRawResponseSchema = z.array(
  z
    .object({
      id: z.number(),
      order_id: z.number().nullish(),
      order_name: z.string(),
      customer: z.string(),
      customer_first_name: z.string().nullish(),
      customer_last_name: z.string().nullish(),
      total: z.string().nullish(),
      status: z.string().nullish(),
      created_at: z.string(),
      updated_at: z.string(),
    })
    .passthrough(),
)

export const LoopReturnsIntegrationResponseDataSchema = z.object({
  apiKey: z.string().nullish(),
})
